import React from 'react';
import BrandclubSideWidget from '../components/BrandclubSideWidget/index.js';

var TextAndVideo = function (_a) {
    var _b;
    var video = _a.video, coverImage = _a.coverImage, title = _a.title, paragraph = _a.paragraph, buttonText = _a.buttonText, buttonLink = _a.buttonLink, page = _a.page, LinkComponent = _a.LinkComponent;
    var fullWidth = !!((_b = page === null || page === void 0 ? void 0 : page.containerConfigOverride) === null || _b === void 0 ? void 0 : _b.width);
    return (React.createElement(BrandclubSideWidget, { fullWidth: fullWidth, leftSideProps: {
            type: 'text',
            title: title,
            subtitle: paragraph,
            buttonText: buttonText,
            buttonLink: buttonLink,
        }, rightSideProps: {
            type: 'video',
            video: video,
            coverImage: coverImage,
        }, LinkComponent: LinkComponent, columnReverse: false }));
};

export { TextAndVideo };
//# sourceMappingURL=index.js.map
